<template>
  <div class="generate-code-list">
    <div>
      <el-form ref="refGenerateForm" :model="productData" label-width="100px" inline>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业码">
              <el-input style="width: 100%;" v-model="productData.enterpriseCode" size="small" disabled
                        placeholder="企业码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品数量">
              <el-input v-model="productData.productCount" size="small" disabled placeholder="产品数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格型号">
              <el-input v-model="productData.productModel" size="small" disabled placeholder="规格型号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="批号">
              <el-input v-model="productData.lotNumber" size="small" disabled placeholder="批号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="一物一码">
              <el-radio-group v-model="qrStatus" @input="onInputChange">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            :data="tableData"
            border>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="waterPumpCode"
              show-overflow-tooltip
              align="center"
              width="250"
              label="水泵码">
          </el-table-column>
          <el-table-column
              prop="enterpriseCode"
              show-overflow-tooltip
              align="center"
              label="企业码">
          </el-table-column>
          <el-table-column
              prop="productCode"
              show-overflow-tooltip
              align="center"
              label="产品码"
              width="120">
          </el-table-column>
          <el-table-column
              prop="serialNumber"
              show-overflow-tooltip
              align="center"
              label="序列号"
              width="100">
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              label="创建时间"
              width="200">
          </el-table-column>
          <el-table-column
              prop="status"
              show-overflow-tooltip
              align="center"
              label="状态"
              width="120">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==='NOT_PASS'" type="danger">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
              <el-tag v-else-if="scope.row.status==='FINISH'||scope.row.status==='REVIEW_PASS'" type="success">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
              <el-tag v-else type="info">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @current-change="onChangeCurrent"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            background
            layout="total, prev, pager, next"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
      <div class="generate-page">
        <el-button type="primary" size="small" round @click="onChangePage(0)">
          上 一 步
        </el-button>
        <el-button type="primary" size="small" round :disabled="!tableData.length" @click="onChangePage(1)">
          下 一 步
        </el-button>
      </div>
    </div>
    <product-info v-if="showInfo"/>
  </div>
</template>

<script>

import {
  getDictionaryItem,
  queryCodeTraceabilityTranslationList,
  sendCodeTraceabilityTranslationType
} from "../../utils/interface";
import ProductInfo from "./ProductInfo";

export default {
  components: {
    ProductInfo,
  },
  data() {
    return {
      showInfo: false,
      tableData: [],
      tableAllData: [],
      productData: {},
      qrStatus: '1',
      queryParams: {
        enterpriseUuid: '',
        productCode: '',
        mainUuid: '',
        current: 1,
        pageSize: 5,
        total: 0,
      },
      enumStatus: [{
        value: 'INIT',
        name: '未审核',
      }, {
        value: 'REVIEW',
        name: '已审核',
      }, {
        value: 'NOT_PASS',
        name: '审核不通过',
      }, {
        value: 'REVIEW_PASS',
        name: '审核通过',
      }, {
        value: 'FINISH',
        name: '已生成',
      },],
      listLoading: false,
    };
  },
  created() {

  },
  methods: {
    initData(product) {
      this.productData = product
      this.queryParams.enterpriseUuid = product.enterpriseUuid
      this.queryParams.productCode = product.productCode
      this.queryParams.mainUuid = product.uuid
      this.qrStatus = '1'
      this.getPageList()
      this.getOptionsData()
    },
    getPageList() {
      this.listLoading = true
      sendCodeTraceabilityTranslationType(this.productData.uuid, this.qrStatus).then((type) => {
        this.tableAllData = type.data
        queryCodeTraceabilityTranslationList(this.queryParams).then((res) => {
          this.listLoading = false
          if (res.list) {
            this.tableData = res.list
            this.queryParams.total = res.total
          }
        }).catch(err => {
          this.listLoading = false
        })
      }).catch(err => {
        this.listLoading = false
      })
    },
    onInputChange() {
      this.$nextTick(() => {
        this.getPageList()
      })
    },
    getOptionsData() {

    },
    onChangePage(type) {
      if (type === 0) {//上一步
        this.$emit('onChangeStep', 1, this.productData)
      } else {//下一步
        this.$emit('onChangeStep', 3, this.productData, {waterPumpList: this.tableAllData})
      }
    },
    onClickClear() {
      this.$refs['refGenerateForm'].resetFields()
      this.queryParams = {
        current: 1,
        pageSize: 5,
        total: 0,
      }
      this.getPageList()
    },
    onChangeCurrent(e) {
      this.queryParams.current = e
      this.getPageList()
    },
    eachDictName(status) {
      return this.enumStatus.find(item => item.value === status).name
    },
  },
};
</script>

<style scoped lang="less">
.generate-code-list {
  .generate-page {
    margin: 50px auto;
    width: 35%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }

  /deep/ .el-form-item__content {
    width: calc(100% - 100px);
  }

  /deep/ .el-form--inline .el-form-item {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceability/GenerateCodeList.vue